// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/snow.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/images/ice.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --gradien-height: 70px;
}

.grid-sizer {
  width: calc(33.333% - 1rem);
  margin-right: 0.35rem;
}

.gutter-sizer {
  width: 1rem;
}

.card {
  position: relative;
  background-color: white;
  width: calc(33.333% - 1rem);
  margin-right: 0.35rem;
  margin-bottom: 1rem;
  overflow: hidden;
  padding: 2.5rem 2rem;
  box-sizing: border-box;
  text-align: left;
  font-size: 14px;
  line-height: 21px;
  border: 1px solid white;
  min-height: 500px;
  max-height: 500px;

  transition: max-height 0.5s ease-in-out, border 0.5s ease-in-out,
    padding 0.5s ease-in-out;
}

.card .new {
  position: absolute;
  background-color: var(--orange);
  color: white;
  height: 20px;
  font-size: 11px;
  display: flex;
  align-items: center;
  padding: 0 0.5rem;
  line-height: 0;
  border-radius: 10px;
  top: 0.5rem;
  left: 0.5rem;
}

.card .tags {
  margin-top: 2rem;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.card .tags span {
  /* flex-wrap: wrap; */
  /* height: auto; */
  line-height: 1.4;
  padding: 0.2rem 0.5rem 0.15rem;
  /* flex: 0 1 min-content; */

  /* height: 20px; */
  /* padding: 0 0.5rem; */
  /* flex: min-content; */

  background-color: var(--orange);
  border-radius: 10px;
  color: white;
  font-size: 11px;
  display: inline-flex;
}

.card .tags span.black {
  background-color: var(--black);
}

.card .tags span.gray {
  background-color: var(--gray);
}

.card h3 {
  font-size: 22px;
  margin: 0;
  padding: 0;
  text-align: center;
}

.card strong {
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  display: block;
}

.card ul.friction-tyre-features {
  margin: 0 0 0 0;
  padding: 0;
  font-size: 11px;
  list-style: none;
}

.card ul.friction-tyre-features li {
  background-size: 36px 35px;
  background-repeat: no-repeat;
  background-position: center left;
  height: 35px;
  display: flex;
  align-items: center;
  padding-left: 2.5rem;
  line-height: 100%;
}

.card ul.friction-tyre-features li.snow {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.card ul.friction-tyre-features li.ice {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.card h4 {
  font-size: 14px;
  font-weight: 400;
  margin: 1.5rem 0 0 0;
  padding: 0;
  text-transform: none;
}

.card ul.prizes {
  margin: 0 0 0 1rem;
  padding: 0;
  font-size: 14px;
}

.card ul.link-list {
  margin-top: 1rem;
}

.card .product-wrapper {
  width: 100%;
  position: absolute;
  bottom: calc(-50% + var(--gradien-height));
  left: 0;
  transition: all 0.5s ease-in-out;
}

.card .product-wrapper .gradient {
  width: 100%;
  height: var(--gradien-height);
  background: linear-gradient(
    0deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  transition: all 0.5s ease-in-out;
}

.card .product-wrapper .product-image {
  background-color: white;
  text-align: center;
}

.card .product-wrapper img {
  width: 75%;
  height: auto;
}

.card .bottom-cover {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  transition: all 0.5s ease-in-out;
  background: white;
  height: 2rem;
  text-align: center;
}

.card .bottom-cover hr {
  border: none;
  height: 1px;
  background-color: #cccac5;
  margin: 0 auto;
  padding: 0;
  width: 80%;
  transition: all 0.5s ease-in-out;
}

/* HOVER */

.card.hover {
  border: 1px solid var(--orange);
  max-height: 1500px;
}

.card.hover .product-wrapper {
  bottom: 0;
}

.card.hover .product-wrapper .gradient {
  height: 0;
}

.card.hover .bottom-cover {
  height: 0rem;
}

.card.hover .bottom-cover hr {
  opacity: 0;
}

@media screen and (max-width: 768px) {
  .grid-sizer {
    width: calc(50% - 1rem);
    margin-right: 0.52rem;
  }

  .gutter-sizer {
    width: 1rem;
  }

  .card {
    width: calc(50% - 1rem);
    margin-right: 0.52rem;
  }
}

@media (max-width: 576px) {
  .grid-sizer {
    width: 100%;
    margin-right: 0;
  }

  .gutter-sizer {
    width: 0;
  }

  .card {
    width: 100%;
    margin-right: 0;
    position: relative !important;
    top: 0 !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Card.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;EAC3B,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;;EAEjB;4BAC0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,2BAA2B;;EAE3B,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;;EAEvB,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,yDAAgD;AAClD;;AAEA;EACE,yDAA+C;AACjD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,0CAA0C;EAC1C,OAAO;EACP,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B;;;;GAIC;EACD,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,gCAAgC;EAChC,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,UAAU;EACV,UAAU;EACV,gCAAgC;AAClC;;AAEA,UAAU;;AAEV;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,eAAe;IACf,6BAA6B;IAC7B,iBAAiB;EACnB;AACF","sourcesContent":[":root {\n  --gradien-height: 70px;\n}\n\n.grid-sizer {\n  width: calc(33.333% - 1rem);\n  margin-right: 0.35rem;\n}\n\n.gutter-sizer {\n  width: 1rem;\n}\n\n.card {\n  position: relative;\n  background-color: white;\n  width: calc(33.333% - 1rem);\n  margin-right: 0.35rem;\n  margin-bottom: 1rem;\n  overflow: hidden;\n  padding: 2.5rem 2rem;\n  box-sizing: border-box;\n  text-align: left;\n  font-size: 14px;\n  line-height: 21px;\n  border: 1px solid white;\n  min-height: 500px;\n  max-height: 500px;\n\n  transition: max-height 0.5s ease-in-out, border 0.5s ease-in-out,\n    padding 0.5s ease-in-out;\n}\n\n.card .new {\n  position: absolute;\n  background-color: var(--orange);\n  color: white;\n  height: 20px;\n  font-size: 11px;\n  display: flex;\n  align-items: center;\n  padding: 0 0.5rem;\n  line-height: 0;\n  border-radius: 10px;\n  top: 0.5rem;\n  left: 0.5rem;\n}\n\n.card .tags {\n  margin-top: 2rem;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n}\n\n.card .tags span {\n  /* flex-wrap: wrap; */\n  /* height: auto; */\n  line-height: 1.4;\n  padding: 0.2rem 0.5rem 0.15rem;\n  /* flex: 0 1 min-content; */\n\n  /* height: 20px; */\n  /* padding: 0 0.5rem; */\n  /* flex: min-content; */\n\n  background-color: var(--orange);\n  border-radius: 10px;\n  color: white;\n  font-size: 11px;\n  display: inline-flex;\n}\n\n.card .tags span.black {\n  background-color: var(--black);\n}\n\n.card .tags span.gray {\n  background-color: var(--gray);\n}\n\n.card h3 {\n  font-size: 22px;\n  margin: 0;\n  padding: 0;\n  text-align: center;\n}\n\n.card strong {\n  font-size: 14px;\n  font-weight: 500;\n  text-align: center;\n  display: block;\n}\n\n.card ul.friction-tyre-features {\n  margin: 0 0 0 0;\n  padding: 0;\n  font-size: 11px;\n  list-style: none;\n}\n\n.card ul.friction-tyre-features li {\n  background-size: 36px 35px;\n  background-repeat: no-repeat;\n  background-position: center left;\n  height: 35px;\n  display: flex;\n  align-items: center;\n  padding-left: 2.5rem;\n  line-height: 100%;\n}\n\n.card ul.friction-tyre-features li.snow {\n  background-image: url(../assets/images/snow.png);\n}\n\n.card ul.friction-tyre-features li.ice {\n  background-image: url(../assets/images/ice.png);\n}\n\n.card h4 {\n  font-size: 14px;\n  font-weight: 400;\n  margin: 1.5rem 0 0 0;\n  padding: 0;\n  text-transform: none;\n}\n\n.card ul.prizes {\n  margin: 0 0 0 1rem;\n  padding: 0;\n  font-size: 14px;\n}\n\n.card ul.link-list {\n  margin-top: 1rem;\n}\n\n.card .product-wrapper {\n  width: 100%;\n  position: absolute;\n  bottom: calc(-50% + var(--gradien-height));\n  left: 0;\n  transition: all 0.5s ease-in-out;\n}\n\n.card .product-wrapper .gradient {\n  width: 100%;\n  height: var(--gradien-height);\n  background: linear-gradient(\n    0deg,\n    rgba(255, 255, 255, 1) 0%,\n    rgba(255, 255, 255, 0) 100%\n  );\n  transition: all 0.5s ease-in-out;\n}\n\n.card .product-wrapper .product-image {\n  background-color: white;\n  text-align: center;\n}\n\n.card .product-wrapper img {\n  width: 75%;\n  height: auto;\n}\n\n.card .bottom-cover {\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  transition: all 0.5s ease-in-out;\n  background: white;\n  height: 2rem;\n  text-align: center;\n}\n\n.card .bottom-cover hr {\n  border: none;\n  height: 1px;\n  background-color: #cccac5;\n  margin: 0 auto;\n  padding: 0;\n  width: 80%;\n  transition: all 0.5s ease-in-out;\n}\n\n/* HOVER */\n\n.card.hover {\n  border: 1px solid var(--orange);\n  max-height: 1500px;\n}\n\n.card.hover .product-wrapper {\n  bottom: 0;\n}\n\n.card.hover .product-wrapper .gradient {\n  height: 0;\n}\n\n.card.hover .bottom-cover {\n  height: 0rem;\n}\n\n.card.hover .bottom-cover hr {\n  opacity: 0;\n}\n\n@media screen and (max-width: 768px) {\n  .grid-sizer {\n    width: calc(50% - 1rem);\n    margin-right: 0.52rem;\n  }\n\n  .gutter-sizer {\n    width: 1rem;\n  }\n\n  .card {\n    width: calc(50% - 1rem);\n    margin-right: 0.52rem;\n  }\n}\n\n@media (max-width: 576px) {\n  .grid-sizer {\n    width: 100%;\n    margin-right: 0;\n  }\n\n  .gutter-sizer {\n    width: 0;\n  }\n\n  .card {\n    width: 100%;\n    margin-right: 0;\n    position: relative !important;\n    top: 0 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
